import {
  Component,
  Input,
  ChangeDetectorRef,
  ViewEncapsulation,
  ViewChild,
  OnInit,
} from '@angular/core';
import {
  NbDialogRef,
  NbDialogService,
  NbThemeService,
} from '@nebular/theme';
import { Subject, Subscription } from 'rxjs';

import { UsersService } from 'app/@core/backend/common/services/users.service';
import { User } from 'app/@core/interfaces/common/users';
import { Router } from '@angular/router';
import {
  FitnessItem,
  SetsBased,
  SettingDetailRow,
  WeightType,
  BlockType,
} from 'app/@core/interfaces/common/CalorieFriend/fitnessItem';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ExerciseProgressData } from 'app/@core/interfaces/common/CalorieFriend/exercise-progress';
import {
  ExerciseLog,
  ExerciseLogData,
} from 'app/@core/interfaces/common/CalorieFriend/exerciseLog';
import {
  Workout,
  WorkoutDetail,
  WorkoutDetailStatus,
} from 'app/@core/interfaces/common/CalorieFriend/workout';
import { FitnessItemPresentationComponentBase } from './fitness-item-presentation-base.component';
import { WorkoutMode, WorkoutService } from 'app/@core/backend/common/services/CalorieFriend/workout.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { ExerciseLogService } from 'app/@core/backend/common/services/CalorieFriend/exerciseLog-service';
/**
 * Component for Overlay presentation of Meal Item.
 * Inherits from the MealItemPresentationComponentBase component.
 */
@Component({
  selector: 'overlay-app-fitness-item-presentation',
  templateUrl: './fitness-item-presentation-overlay.component.html',
  styleUrls: ['./fitness-item-presentation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OverlayFitnessItemPresentationComponent
  extends FitnessItemPresentationComponentBase
  implements OnInit {
  constructor(
    OverlayDialogService: NbDialogService,
    private OverlayUsersService: UsersService,
    private OverlayRouter: Router,
    private sanitizer: DomSanitizer,
    private OverlayExerciseProgressService: ExerciseProgressData,
    private exerciseLogService: ExerciseLogService,
    private workoutService: WorkoutService,
    private theme: NbThemeService,
    private cdRef: ChangeDetectorRef,
    private OverlayDialogRef: NbDialogRef<OverlayFitnessItemPresentationComponent>,
  ) {
    super(OverlayDialogService, OverlayExerciseProgressService);
  }

  currentUser: User = null;
  isPatientView: boolean = false;

  safeYoutubeSrc: SafeResourceUrl;
  settingDetails: SettingDetailRow[] = [];

  @ViewChild('chart', { static: false })
  _chart: any;
  _chartData: ExerciseLog[] = [];

  graphData: any = null;
  graphOptions: any;

  lastTimeCompleted = '';

  dateTimeOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  /**
   * occured when skipped or completed exercise
   */
  @Input('OnNextHandler')
  onNextHandler: (data: {
    status: WorkoutDetailStatus;
    exLogId?: number;
    nextIndex?: number;
  }) => void;

  @Input('pending')
  pending = true;

  /**
   * @description Description of Exercise; ex. A1, A1 - Set 1
   */
  @Input('currentExercise')
  currentExercise: string = '';


  @Input('setNumber')
  setNumber: number = 0;
  /**
  /**
   * @description true if dialog is opened in workout mode
   */
  @Input('isWorkout')
  isWorkout: boolean = false;

  readonly WorkoutDetailStatus = WorkoutDetailStatus;
  workoutSubscription: Subscription;
  currentBlockLabel = '';
  workout: Workout;
  private destroy$ = new Subject<void>();

  ngOnInit() {
    super.ngOnInit();
    this.workoutSubscription = this.workoutService.workout.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.workout = res;
    });
    this.OverlayDialogRef.onClose.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.isWorkout) {
        this.workoutService.pauseWorkout().finally(() => {
          this.workoutSubscription?.unsubscribe();
        });
      }
    });
    this.init();
  }

  init(): void {
    this.pending = true;
    if (this.Item) {
      this.OverlayExerciseProgressService
        .getOneMaxRep(this.PatientID, this.Item.exerciceId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (data) => {
            if (data) this.Item.oneRepMax = data.oneMaxRep;
          },
          () => { }
        );
    }

    this.currentBlockLabel = this.OrderLabel;


    if (!this.currentExercise) {
      this.currentExercise = `${this.currentBlockLabel}${this.Item.order + 1}`;
    }
    if (this.Item.youtubeUrl && this.Item.youtubeUrl != 'null') {
      const id: string = this.Item.youtubeUrl.split('v=')[1];
      this.Item.youtubeUrl = 'https://www.youtube.com/embed/' + id;
    }

    this.safeYoutubeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.Item.youtubeUrl
    );

    this.loadExerciceData();

    const loadUser = this.OverlayUsersService.getCurrentUser();
    loadUser.subscribe((user) => {
      this.currentUser = user;
    });

    this.isPatientView = this.OverlayRouter.url.includes('/PatientView/');
  }
  loadExerciceData() {
    this.exerciseLogService
      .getLastExerciseLog(this.Item.id)
      .pipe(
        finalize(() => this.pending = false),
        takeUntil(this.destroy$),
      )
      .subscribe((data) => {
        this.settingDetails = JSON.parse(this.Item.setSettings);//FitnessItemHelper.GetSetSettings(this.Item);

        if (data.id === 0) {
          this.lastTimeCompleted = 'Never';
        } else {
          const lastDetails = JSON.parse(data.snapshot);
          for (const detail of this.settingDetails) {
            const logDetail = lastDetails.find((d) => d.Set === detail.Set);
            if (logDetail) {
              detail.UsedWeight = logDetail.UsedWeight;
              detail.RepsDone = logDetail.RepsDone;
            }
          }
          this.lastTimeCompleted = new Date(data.dateTime).toLocaleDateString(
            undefined,
            this.dateTimeOptions as any
          );
        }

        for (const detail of this.settingDetails) {
          let weight = +detail.Weight;
          let convert: boolean = false;

          if (weight == 0 && this.Item.defaultWeight > 0) {
            weight = +this.Item.defaultWeight;
            convert = true; //do not convert "advanced settings" but do convert defaultWeight. (this is weird, to be evaluated)
          }

          let result = 0;
          if (this.Item.weightType === WeightType.Procent1MR) {
            result = this.Item.oneRepMax * (weight / 100);
          } else result = weight;

          if (this.IsPreferredUnitImperial) {
            result = Math.round(result * 2.20462);
          } else {
            // result *= 2.205;
          }

          // if ((this.Item.setsBased === SetsBased.TimeBased)) {
          //    detail.RepsOrTime =  (Number(detail.RepsOrTime) / 60).toString();
          // }


          detail.CalculatedWeight = result;
          // weight *=2.205;
          // if(this.IsPreferredUnitImperial)
          // result *=2.205;
          if (this.Item.weightType === WeightType.Procent1MR) {
            if (this.Item.oneRepMax === null || this.Item.oneRepMax === 0) {
              detail.displayWeight = weight.toString() + ' % 1MR';
            } else {
              detail.displayWeight = `${Math.trunc(result).toFixed(1)} (${(weight)} % 1MR)`;
            }
          } else {
            detail.displayWeight = result.toString();
          }


        }

        this.updateSettingsForCircuit();
        this.updateSettingsForSuperSet();

        setTimeout(() => {
          this.refreshGraph();
        }, 200);

        this.OverlayDialogRef.onBackdropClick.pipe(takeUntil(this.destroy$)).subscribe(async () => {
          this.OverlayDialogRef.close();

          /*if (await this.shouldDialogClose()) {
            this.OverlayDialogRef.close();
          }*/
        });
      });
  }


  get OrderLabel(): string {
    if (this.fitnessBlock.order > 0 && this.fitnessBlock.order < 100) {
      return (
        String.fromCharCode(64 + this.fitnessBlock.order)
      );
    } else {
      return "";
    }
  }


  ngAfterViewInit() { }

  get isCompleted() {
    let currentItem = this.workout?.patientWorkoutDataDetails?.find((d) => d.itemId === this.Item.id);
    return currentItem?.status === WorkoutDetailStatus.Completed && currentItem?.isCircuitSetNumber >= this.fitnessBlock.repetitionCount;
  }

  getExerciseStatus(itemId: number, order: number) {
    const founded: WorkoutDetail = this.workout?.patientWorkoutDataDetails?.find((d) => d.itemId === itemId);
    if (founded) {
      return founded.status;
    } else {
      return order === this.Item.order ? this.workoutService.workoutModeToString() : 'Pending';
    }
  }

  getSupersetTag(item: FitnessItem) {
    const founded: WorkoutDetail = this.workout?.patientWorkoutDataDetails?.find((d) => d.itemId === item.id);
    if (item.setsBased === SetsBased.Superset) {
      return `${item.sets}/${founded ? founded.isSupersetNumber : 0}`;
    }
    return null;

  }


  isItemCompleted(item: WorkoutDetail): boolean {
    const itemData = this.fitnessBlock.items.find((i) => i.id === item.itemId);
    return item.status === WorkoutDetailStatus.Completed && (item.isCircuitSetNumber >= this.fitnessBlock.repetitionCount || this.fitnessBlock.blockType !== BlockType.Circuit) && (item.isSupersetNumber >= itemData.sets || itemData.setsBased !== SetsBased.Superset);
  }

  getExerciseIcon(item): string {
    switch (this.getExerciseStatus(item.id, item.order).toLocaleLowerCase()) {
      case 'completed':
        return 'fa fa-check-double text-success'; // Font Awesome class for check mark with green color
      case 'skipped':
        return 'fa fa-forward text-warning'; // Font Awesome class for fast forward with yellow color
      case 'pending':
        return 'fa fa-hourglass-start text-primary'; // Font Awesome class for hourglass with blue color
      default:
        return 'fa fa-dumbbell text-secondary'; // Font Awesome class for exercise with grey color
    }
  }
  // Circuits are always 1X Reps
  updateSettingsForCircuit() {
    if (this.BlockType === BlockType.Circuit.valueOf()) {
      if (this.settingDetails.length > 1) {
        let firtsItem = this.settingDetails[0];
        this.settingDetails = [];
        this.settingDetails.push(firtsItem);
        this.settingDetails[0].Rest = this.fitnessBlock.circuitRest.toString();
      }

      this.fitnessBlock.items[0].imageUrl;
    }
  }

  updateSettingsForSuperSet() {

    //if (this.setNumber == 0) return;

    if (this.IsSuperSetWithNext || this.IsSuperSet) {
      if (this.settingDetails.length > 1) {
        let firtsItem = this.settingDetails[0];
        this.settingDetails = [];
        this.settingDetails.push(firtsItem);
        this.settingDetails[0].Rest = this.GetSupersetMaster?.defaultRest.toString();

      }

      this.fitnessBlock.items[0].imageUrl;
    }
  }


  public getVideoUrl(source: string): string {
    return source + "#t=0.001"
  }


  forceChartRefresh() {
    return;
  }

  async onClose() {
    this.OverlayDialogRef.close();
    return;
  }

  onStopWorkout() {
    this.OverlayDialogRef.close(WorkoutMode.Complete);
    this.workoutService.redoWorkout();
  }

  @Input('ShouldDialogClose')
  async shouldDialogClose(): Promise<boolean> {
    return true;
  }
  get RepLabel() {
    if (this.Item.setsBased === SetsBased.RepsBased || this.Item.setsBased === SetsBased.Superset) return 'Reps';
    if (this.Item.setsBased === SetsBased.MaxRepBased) return 'Max Reps';
    else return 'Time (min.)';
  }

  get IsMaxRep(): boolean {
    if (this.Item.setsBased === SetsBased.MaxRepBased) return true;
    return false;
  }


  refreshGraph() {
    // graph data
    this.exerciseLogService
      .getExerciseLogsListByExerciseId(this.PatientID, this.Item.exerciceId)
      .then((data: ExerciseLog[]) => {
        this._chartData = data.sort((a, b) => new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime()).slice(0, 10).reverse();
        this.theme.getJsTheme().subscribe((config) => {
          const colors = config.variables;
          const chartjs: any = config.variables.chartjs;

          const labels = this._chartData.map((b) =>
            new Date(b.dateTime).toLocaleDateString('en', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })
          );
          const valuesFirstSetWeight = this._chartData.map((b) => b.firstSetWeight);
          const valuesFirstRepDone = this._chartData.map((b) => JSON.parse(b.snapshot)?.[0]?.RepsDone);
          this.graphData = {
            labels: labels,
            datasets: [
              {
                data: valuesFirstSetWeight,
                label: 'First Set Weight',
                fill: false,
                backgroundColor: '#3498db',
                borderColor: '#3498db',
                borderWidth: 1,
              },
              {
                data: valuesFirstRepDone,
                label: 'First Rep Done',
                fill: false,
                backgroundColor: '#e74c3c',
                borderColor: '#e74c3c',
                borderWidth: 1,
              }
            ],
          };

          this.graphOptions = {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
              duration: 0,
              onComplete: () => {
                console.log('completed', this._chart.canvas);
              },
            },
            scales: {
              xAxes: [
                {
                  gridLines: {
                    display: false,
                    color: chartjs.axisLineColor,
                  },
                  ticks: {
                    fontColor: chartjs.textColor,
                  },
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    display: false,
                    color: chartjs.axisLineColor,
                  },
                  ticks: {
                    fontColor: chartjs.textColor,
                  },
                },
              ],
            },
            legend: {
              labels: {
                fontColor: chartjs.textColor,
                usePointStyle: true,
                pointStyle: 'circle',
                lineWidth: 0,
              },
              position: 'bottom',
            },
          };

          this.forceChartRefresh();
        });
      });
  }

  async onNext(status: WorkoutDetailStatus, exLogId?: number) {
    this.pending = true;
    if (this.onNextHandler && this.isWorkout) {
      await this.onNextHandler({ status, exLogId, nextIndex: -1 });
      this.OverlayDialogRef.close();
    }
    this.pending = false;
  }

  async onGoToIndex(status: WorkoutDetailStatus, exLogId?: number, index?: number) {
    this.pending = true;
    if (this.onNextHandler && this.isWorkout) await this.onNextHandler({ status, exLogId, nextIndex: index });
    else {
      this.Item = this.fitnessBlock.items[index];
      this.OverlayItem = this.Item;
      this.init();
    }
    this.pending = false;
  }

  async saveExerciseLog() {
    this.pending = true;
    const exLog: any = {
      patientID: this.PatientID,
      fitnessItemID: this.Item.id,
      exerciceId: this.Item.exerciceId,
      snapshot: JSON.stringify(this.settingDetails),
      firstSetWeight: +this.settingDetails[0]?.UsedWeight,
      firstRepsDone: +this.settingDetails[0]?.RepsDone,
    };

    await this.exerciseLogService.create(exLog).toPromise();
    // refresh graph
    this.refreshGraph();

    this.loadExerciceData();

    const data = await this.exerciseLogService
      .getLastExerciseLog(this.Item.id)
      .toPromise();

    if (data.id === 0) {
      this.lastTimeCompleted = 'Never';
    } else {
      this.lastTimeCompleted = new Date(data.dateTime).toLocaleDateString(
        undefined,
        this.dateTimeOptions as any
      );
    }

    const exProgress: any = {
      patientID: this.PatientID,
      exerciceId: this.Item.exerciceId,
      oneMaxRep: this.Item.oneRepMax,
      firstSetWeight: +this.settingDetails[0]?.UsedWeight,
      firstRepDone: +this.settingDetails[0]?.RepsDone,
    };

    await this.OverlayExerciseProgressService.changeOneMaxRepByPatient(
      exProgress
    ).toPromise();

    await this.onNext(WorkoutDetailStatus.Completed, data.id);
  }
}
